const URI = require('urijs')

/**
 * Add or replaces the URL resource extension to .json.
 * Used to keep the original page URL but request
 * dynamic data in the JSON format explicitly.
 *
 * @example
 *   addJsonExtension('/community/events') // It returns '/community/events.json'
 */
export function addJsonExtension (url) {
  return URI(url).suffix('json').toString()
}



// WEBPACK FOOTER //
// ./front/apps/public/pages/community/javascripts/utils/url.js